export default import.meta.ROLLDOWN_FILE_URL_7x1gIblQLfzctElDF6jsiw